module.exports = __webpack_public_path__ + "static/media/integration.22fa109e.jpg";